import { render, staticRenderFns } from "./BlockOverlayLayerLegacy.vue?vue&type=template&id=58b091bc&scoped=true"
import script from "./BlockOverlayLayerLegacy.vue?vue&type=script&lang=js"
export * from "./BlockOverlayLayerLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b091bc",
  null
  
)

export default component.exports